<div class="main-content">
	<div class="col-md-12">

		<div class="container-fluid tp-box" [@flipState]="flip">
			<div class="row tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">

			</div>
			<div class="row tp-box__side tp-box__front dashboard-cards-row" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
				<div class="col-md-3 dashboard-card-col" [ngClass]="viewingCard === 'quotes' ? 'col-md-12' : 'col-md-3'">
					<app-customer-open-quotes (viewData)="viewingData($event, 'quotes')"></app-customer-open-quotes>
				</div>
				<div class="col-md-3 dashboard-card-col" [ngClass]="viewingCard === 'newcustomers' ? 'col-md-12' : 'col-md-3'">
					<app-new-customers (viewData)="viewingData($event, 'newcustomers')"></app-new-customers>
				</div>
				<div class="col-md-3 dashboard-card-col" [ngClass]="viewingCard === 'nopurchase' ? 'col-md-12' : 'col-md-3'">
					<app-customer-no-purchase (viewData)="viewingData($event, 'nopurchase')"></app-customer-no-purchase>
				</div>
				<div class="col-md-3 dashboard-card-col" [ngClass]="viewingCard === 'tophundred' ? 'col-md-12' : 'col-md-3'">
					<app-top-hundred [dashboard]="true" (viewData)="viewingData($event, 'tophundred')"></app-top-hundred>
				</div>
				<div class="col-md-12">
					<div class="card">
						<div class="card-body">
							<app-dashboard-sales-this-last></app-dashboard-sales-this-last>
						</div>
					</div>
				</div>



				<div class="col-md-12">
					<app-brand-report [customer]="false"></app-brand-report>
				</div>
				<app-dashboard-cat-line *ngIf="telegramAllowed"></app-dashboard-cat-line>
			</div>
		</div>
	</div>
</div>
